import { DrawingBasketDto } from "./drawing-basket.dto";

export class DrawingEuroPlayoffRequest {
    championsLeagueBasket: DrawingBasketDto;
	euroLeagueBasket: DrawingBasketDto;
	conferenceLeagueBasket: DrawingBasketDto;
	
	stage: number;
	
	matchDay1: number;
	matchDay2: number;
}